import { plainToInstance, Transform } from "class-transformer";
import { toEuros } from "@/utils/numberUtils";
import { UserDto } from "@/core/features/users/user.dto";

export class CertificationHasOnCallAnalysisDto {
  onCallTypeName: string;

  operativeUnitId: string;

  operativeUnitName: string;

  certificationId: string;

  days: number;

  @Transform(({ value, obj }) => plainToInstance(UserDto, { username: value, operativeUnitId: obj.operativeUnitId }))
  user: UserDto;

  @Transform(({ value }) => toEuros(value))
  cost = 0;

  @Transform(({ value }) => toEuros(value))
  totalCost = 0;
}
